export const getAppOrigin = (): string => window.location.origin;
